'use client';
function createKeyPressHandlers(e, r, ...n) {
    return (t)=>{
        (n.includes(t.key) || t.keyCode === r || t.which === r) && e(t);
    };
}
function emulateClick(e) {
    e && e.current && 'function' == typeof e.current.click && e.current.dispatchEvent(new Event('click'));
}
function createClickOnEnterHandler(e) {
    return createKeyPressHandlers(()=>emulateClick(e), 13, 'Enter');
}
function createClickOnSpaceHandler(e) {
    return createKeyPressHandlers(()=>emulateClick(e), 32, ' ', 'Spacebar');
}

export { createClickOnEnterHandler, createClickOnSpaceHandler, createKeyPressHandlers };
